import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { StateProvider } from './state';
import reducer from './reducer';

import SearchField from './components/SearchField';
import t from '../../utils/t';
import { getParameterFromQuery } from "../../utils/parseQuery";

const Layout = (props) => {
  const { isMap, children } = props;

  if (!isMap) {
    return (
      <div className="container column">
        <div className="columns is-centered">
          <div className="column is-8">
            <h1 className="shop-search__title">{t('stores.search.store-finder')}</h1>
            {children}
          </div>
        </div>
      </div>
    )
  }

  return (children)
};

export const ShopSearch = (props) => {
  const initialState = {
    voucher: Boolean(window.options.filters.voucher || 0),
    giftCard: Boolean(window.options.filters.gift_card || 0),
    taxFree: Boolean(window.options.filters.tax_free || 0),
    floor: Number(getParameterFromQuery('floor', window.location.search) || props.floor || 0),
  };

  return(
    <StateProvider initialState={initialState} reducer={reducer}>
      <Layout {...props}>
        <SearchField {...props} />
      </Layout>
    </StateProvider>
  )
};

if (document.getElementById('shop-search')) ReactDOM.render(<ShopSearch />, document.getElementById('shop-search'));



// WEBPACK FOOTER //
// ./resources/assets/js/components/shop-search/App.jsx